import initScrollReveal from "./scripts/scrollReveal";
import initGraduatedCarousel from "./scripts/graduatedCarousel";
import initTiltEffect from "./scripts/tiltAnimation";
import { targetElements, defaultProps } from "./data/scrollRevealConfig";

initScrollReveal(targetElements, defaultProps);
initGraduatedCarousel();
initTiltEffect();
